export const getIconColor = (isActive) => {
  return isActive ? '#fff' : '#4076B4'
}
